document.addEventListener('DOMContentLoaded', function() {


  const menPressSlider = new Swiper('.pi-women_press_logo', {
    slidesPerView: 2,
    slidesPerGroup: 1,
    spaceBetween: 30,
    pagination: false,
    loop: true,
    breakpoints: {
      813: {
        slidesPerView: 4,
        // centeredSlides: false,
        // variableWidth: false
      }
    }
  });
  
  const menPressContent = new Swiper('.pi-women_press_testimonials', {
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    thumbs: {
      swiper: menPressSlider
    }
  });
  
  
  
  });